export const NetworkConnectivity = "network.connectivity";
export const ClipboardAccess = "command.clipboardAccess";
export const ClipboardContent = "clipboard.lastKnownContent";

export interface WebmateDevice {
  id: string;
  properties: any;
  metadata: any;
}
